// Route paths and the helpers that build them.
//
// Deliberately free of component imports. `router.js` pulls in every page, so a leaf
// component that only wants a URL must import from here — importing `router.js` for a
// constant creates a page <-> component cycle that blows up under jest.mock.

export const ROUTES = {
  root: "/",
  dashboard: "/dashboard",
  dashboardUsageDrop: "/dashboard/usage-drop",
  login: "/login",
  customers: "/customers",
  customerDetails: "/customers/:id",
  forecast: "/forecast",
  churn: "/churn",
  voice: "/voice",
  calendar: "/calendar",
  feedback: "/feedback",
  settings: "/settings",
  profile: "/settings?tab=profile",
  helpAndDocs: "/help",
  logout: "/logout",
  integrations: "/integrations",
};

/** Build a customer detail URL. Use instead of hardcoding `/customers/${id}`. */
export const customerDetailPath = (id) => `/customers/${id}`;

/**
 * Deep link to one provider's pane on the Integrations page.
 *
 * Integrations used to live behind a Settings tab, so CTAs across the app pointed at
 * `/settings`. They now land on Team Settings — the right page for none of them. Route
 * through here so there is a single place that knows where an integration is configured.
 *
 * Callers must pass an id the page can actually render (see the Integrations catalog);
 * an unknown id silently resolves to the page's default provider, which is an integration
 * the caller never mentioned. Omit the id to open the page without preselecting anything.
 */
export const integrationPath = (id) =>
  id
    ? `${ROUTES.integrations}?integration=${encodeURIComponent(id)}`
    : ROUTES.integrations;
